var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-alert-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "vue-alert",
        class: [_vm.typeClass, _vm.center ? "vue-alert_center" : ""],
        attrs: { role: "alert" },
      },
      [
        _vm.showIcon
          ? _c("i", {
              staticClass: "vue-alert__icon",
              class: [_vm.iconClass, _vm.isBigIcon],
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "vue-alert__content" }, [
          _vm.title || _vm.$slots.title
            ? _c(
                "span",
                { staticClass: "vue-alert__title", class: [_vm.isBoldTitle] },
                [
                  _vm._t("title", function () {
                    return [_vm._v(_vm._s(_vm.title))]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.description && !_vm.$slots.description
            ? _c(
                "span",
                { staticClass: "vue-alert__description" },
                [
                  _vm._t("default", function () {
                    return [_vm._v(_vm._s(_vm.description))]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.description && !_vm.description
            ? _c(
                "span",
                { staticClass: "vue-alert__description" },
                [_vm._t("description")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "i",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.closable,
                  expression: "closable",
                },
              ],
              staticClass: "vue-alert__close-btn",
              class: {
                "is-customed": _vm.closeText !== "",
                "fa fa-times": _vm.closeText === "",
              },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.closeText))]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }